"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.locales = void 0;
const localized_strings_1 = __importDefault(require("localized-strings"));
exports.locales = new localized_strings_1.default({
    en: {
        afterText: ' or by scanning the QR code',
        beforeText: 'Pay securely using ',
        linkText: 'this link',
    },
    fr: {
        afterText: ' ou en scannant le QR code',
        beforeText: 'Payez en toute sécurité via ',
        linkText: 'ce lien',
    },
});
